/**
 * 安全设置
 * @returns
 */
import {
  Box,
  Flex,
  Text,
  Image,
  Center,
  Button,
  Input,
  HStack,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  FormErrorMessage,
  useToast,
} from "@chakra-ui/react";
import ImgWx from "@/assets/images/img_wx.png";
import { useState } from "react";
import AccessHistoryModal from "./accessHistoryModal";
import { Field, Form, Formik, FormikErrors } from "formik";
import { isPhone, isEmail } from "@/utils/utils";
import { useGetCodeMutation, useUpdateUserMutation } from "@/services/api/endpoints/users";
import { useSelector, useDispatch } from "react-redux";
import { updateUser, selectUser } from "@/reducer/userslice";
import { UserProfile } from "@/types/user";
import { ServerError } from "@/types/errors";
import QRCode from 'qrcode.react';

type AccessData = {
  createAt: string;
  state: string;
  ip: string;
  id: string;
};

const SecuritySet = () => {
  const emailControl = useDisclosure();
  const phoneControl = useDisclosure();
  const bindWxControl = useDisclosure();
  const passwordControl = useDisclosure();
  const accessControl = useDisclosure();

  const dispatch = useDispatch();
  const toast = useToast();
  const user = useSelector(selectUser);
  const email = user.email;
  const phone = user.phone;

  const [isVerifyNewPhone, setIsVerifyNewPhone] = useState(false);
  const [isBindWx, setIsBindWx] = useState(false);
  const [wxQrcode, setWxQrcode] = useState("");
  const [password, setPassword] = useState("");
  const [newPassword1, setNewPassword1] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [phoneBtnTxt, setPhoneBtnTxt] = useState("发送验证码");
  const [isPhoneDisable, setIsPhoneDisable] = useState(false);
  

  const [getCode] = useGetCodeMutation();
  const [UpdateUser] = useUpdateUserMutation();

  const handleChangeEmail = () => {
    emailControl.onOpen();
  };

  const emailForm = {
    email: "",
    email2: "",
    password: "",
  };
  const handleValidate1 = (values: { email: string; email2: string; password: string }) => {
    const errors: FormikErrors<{ email: string; email2: string; password: string }> = {};
    if (!values.email) {
      errors.email = "邮箱不能为空";
    } else if (!isEmail(values.email)) {
      errors.email = "无效的电子邮件地址";
    }
    if (!values.email2) {
      errors.email2 = "邮箱不能为空";
    } else if (!isEmail(values.email2)) {
      errors.email2 = "无效的电子邮件地址";
    }else if (values.email !== values.email2) {
      errors.email2 = "邮件地址不一致";
    }
    if (!values.password) {
      errors.password = "密码不能为空";
    }
    return errors;
  };

  const handleSubmitEmail = async (values: { email: string; email2: string; password: string }) => {
    const newData = {
      email: values.email,
      password: values.password
    } as UserProfile;
    const result = await UpdateUser(newData)
      .unwrap()
      .catch((e) => {
        toast({
          title: (e as ServerError).message,
          position: "top",
          status: "error",
          duration: 2000,
          isClosable: true,
        });
      });
    if (result) {
      dispatch(updateUser(result));
      emailControl.onClose();
    }
    
  };

  const handleCloseEmail = () => {
    emailControl.onClose();
  };

  const handleChangePhone = () => {
    phoneControl.onOpen();
  };

  const newPhoneForm = {
    phone: "",
    code: "",
  };
  const handlePhoneValidate2 = (values: {
    phone: string;
    code: string;
  }) => {
    const errors: FormikErrors<{ phone: string; code: string }> = {};
    if (!values.phone) {
      errors.phone = "手机号不能为空";
    } else if (!isPhone(values.phone)) {
      errors.phone = "无效的手机号";
    }
    if (!values.code) {
      errors.code = "验证码不能为空";
    }
    return errors;
  };

  const handleChangePhoneNext = () => {
    setIsVerifyNewPhone(true);
  };

  const handleClosePhone = () => {
    setIsVerifyNewPhone(false);
    phoneControl.onClose();
  };

  const handleSumbitPhone = async (values: {phone: string; code: string;}) => {
    const result = await UpdateUser(values as UserProfile)
      .unwrap()
      .catch((e) => {
        toast({
          title: (e as ServerError).message,
          position: "top",
          status: "error",
          duration: 2000,
          isClosable: true,
        });
      });
    if (result) {
      dispatch(updateUser(result));
      setIsVerifyNewPhone(false);
      phoneControl.onClose();
    }
  };

  const handleGetPhoneCode = async (
    fn: Function,
    values: { phone: string; code: string }
  ) => {
    let seconds = 60;
    var phoneInterval: any;
    if (isPhone(values.phone)) {
      const res = await getCode({ phone: values.phone }).unwrap();
      if (res.status) {
        setInterval(() => {
          if (seconds-- <= 0) {
            seconds = 60;
            setIsPhoneDisable(false);
            setPhoneBtnTxt("获取验证码");
            clearInterval(phoneInterval);
          } else {
            setIsPhoneDisable(true);
            setPhoneBtnTxt(seconds + "s后重新获取");
          }
        }, 1000);
      }
    } else {
      fn("phone", true, true);
    }
  };

  const handleBindWx = () => {
    bindWxControl.onOpen();
  };
  const handleUnBindWx = () => {
    console.log("解除绑定")
  }
  const handleSetPassword = () => {
    passwordControl.onOpen();
  };

  const handleChangePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
  };
  const handleChangeNewPassword1 = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
  };
  const handleChangeNewPassword2 = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
  };

  const handleClosePassword = () => {
    passwordControl.onClose();
  };

  const handleSumbitPassword = () => {
    passwordControl.onClose();
  };

  const handleAccessHistory = () => {
    accessControl.onOpen();
  };

  const devicesList = [
    {
      type: "网页",
      status: "已登录",
      lastLogin: "2024年3月30日21:35",
    },
    {
      type: "H5",
      status: "已登录",
      lastLogin: "2024年3月30日21:35",
    },
  ];
  const accessHistoryData: AccessData[] = [
    {
      createAt: "2023年3月30日",
      state: "登录成功",
      ip: "127.0.0.1",
      id: "fhjggfasfshkfkfkfydfkhfgfhf",
    },
  ];
  return (
    <Box overflow={"hidden"}>
      <Box width="80%" m="0 auto">
        <Box
          mt="40px"
          mb="20px"
          color="#27314D"
          fontWeight="bold"
          fontSize="24px"
        >
          安全设置
        </Box>
        <Box ml="20px" mb="50px">
          <Box mb="24px" color={"#27314D"} fontSize="18px" fontWeight={500}>
            绑定账号
          </Box>
          <Flex alignItems={"flex-end"} mb="20px">
            <Box fontSize={"14px"}>
              <Text mb={"10px"} color="#333333">
                当前邮箱
              </Text>
              <Input
                h="40px"
                w="300px"
                boxSizing="border-box"
                borderRadius={0}
                bg="rgba(238, 241, 247, 0.5)"
                color={"#7F7F7F"}
                fontSize="12px"
                placeholder="请输入"
                size="md"
                value={email}
                isDisabled
              />
            </Box>
            <Button
              w="102px"
              h="40px"
              ml="14px"
              bg="#F2F2F2"
              color={"#333333"}
              fontSize="14px"
              fontWeight={"normal"}
              borderRadius={0}
              _hover={{}}
              onClick={handleChangeEmail}
            >
              更换邮箱
            </Button>
          </Flex>
          <Flex alignItems={"flex-end"} mb="20px">
            <Box fontSize={"14px"}>
              <Text mb={"10px"} color="#333333">
                绑定手机号
              </Text>
              <Input
                h="40px"
                w="300px"
                boxSizing="border-box"
                borderRadius={0}
                bg="rgba(238, 241, 247, 0.5)"
                color={"#7F7F7F"}
                fontSize="12px"
                placeholder="请输入"
                size="md"
                value={phone}
                isDisabled
              />
            </Box>
            <Button
              w="102px"
              h="40px"
              ml="14px"
              bg="#F2F2F2"
              color={"#333333"}
              fontSize="14px"
              fontWeight={"normal"}
              borderRadius={0}
              _hover={{}}
              onClick={handleChangePhone}
            >
              更换手机号
            </Button>
          </Flex>
          <Flex mb={"17px"} fontSize={"14px"}>
            <Text color="#333333">绑定微信账号</Text>
            <Text ml="20px" color="#AAAAAA">
            {isBindWx ? "已绑定" : "未绑定"}
            </Text>
          </Flex>
          <Flex>
            <Image display={isBindWx ? "bold" : "none"} src={ImgWx} mr="16px" />
            {isBindWx &&
            <Button
            w="102px"
            h="40px"
            bg="#F2F2F2"
            color={"#333333"}
            fontSize="14px"
            fontWeight={"normal"}
            borderRadius={0}
            _hover={{}}
            onClick={handleUnBindWx}
          >
            解除绑定
          </Button>
            }
            {
              !isBindWx &&
              <Button
              w="102px"
              h="40px"
              bg="#F2F2F2"
              color={"#333333"}
              fontSize="14px"
              fontWeight={"normal"}
              borderRadius={0}
              _hover={{}}
              onClick={handleBindWx}
            >
              立即绑定
            </Button>
            }
            
          </Flex>
          {/* <Box
            mb="24px"
            mt="49px"
            color={"#27314D"}
            fontSize="18px"
            fontWeight={500}
          >
            密码设置
          </Box>
          <Button
            w="102px"
            h="40px"
            bg="#F2F2F2"
            color={"#333333"}
            fontSize="14px"
            fontWeight={"normal"}
            borderRadius={0}
            _hover={{}}
            onClick={handleSetPassword}
          >
            去设置
          </Button>
          <Box mt="35px" color={"#27314D"} fontSize="18px" fontWeight={500}>
            设备管理
          </Box>
          <Flex alignItems={"center"} gap="70px">
            <Text color="#7F7F7F" fontSize={"12px"}>
              你的账号在以下设备中登录过，你可以删除设备，删除后在设备登录时需进行安全验证。
            </Text>
            <Button
              w="102px"
              h="40px"
              bg="#F2F2F2"
              color={"#333333"}
              fontSize="14px"
              fontWeight={"normal"}
              borderRadius={0}
              _hover={{}}
            >
              退出所有设备
            </Button>
          </Flex>
          <Box mt="20px">
            <TableContainer>
              <Table
                variant="simple"
                border={"1px solid #E0E0E0"}
                fontSize="14px"
                fontWeight={"normal"}
              >
                <Thead color={"#333333"}>
                  <Tr>
                    <Th
                      fontSize="12px"
                      fontWeight={"normal"}
                      textAlign="center"
                      border={"1px solid #E0E0E0"}
                    >
                      设备类型
                    </Th>
                    <Th
                      fontSize="12px"
                      fontWeight={"normal"}
                      textAlign="center"
                      border={"1px solid #E0E0E0"}
                    >
                      当前状态
                    </Th>
                    <Th
                      fontSize="12px"
                      fontWeight={"normal"}
                      textAlign="center"
                      border={"1px solid #E0E0E0"}
                    >
                      最后登录时间
                    </Th>
                    <Th
                      fontSize="12px"
                      fontWeight={"normal"}
                      textAlign="center"
                    >
                      操作
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {devicesList.map((row, index) => {
                    return (
                      <Tr key={index} color="#333333">
                        <Td textAlign="center" border={"1px solid #E0E0E0"}>
                          {row.type}
                        </Td>
                        <Td textAlign="center" border={"1px solid #E0E0E0"}>
                          {row.status}
                        </Td>
                        <Td textAlign="center" border={"1px solid #E0E0E0"}>
                          {row.lastLogin}
                        </Td>
                        <Td textAlign="center" border={"1px solid #E0E0E0"}>
                          <Center gap="30px">
                            <Button
                              variant="link"
                              fontSize={"12px"}
                              color="#333333"
                              fontWeight={"normal"}
                            >
                              查看详情
                            </Button>
                            <Button
                              variant="link"
                              fontSize={"12px"}
                              color="#333333"
                              fontWeight={"normal"}
                            >
                              退出设备
                            </Button>
                            <Button
                              variant="link"
                              fontSize={"12px"}
                              color="#333333"
                              fontWeight={"normal"}
                            >
                              注销
                            </Button>
                          </Center>
                        </Td>
                      </Tr>
                    );
                  })}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
          <Box
            mt="35px"
            mb="10px"
            color={"#27314D"}
            fontSize="18px"
            fontWeight={500}
          >
            OAuth 2.0 应用
          </Box>
          <Text color="#7F7F7F" fontSize={"12px"}>
            没有任何授权的 OAuth2.0 应用
          </Text>
          <Box
            mt="35px"
            mb="20px"
            color={"#27314D"}
            fontSize="18px"
            fontWeight={500}
          >
            访问历史
          </Box>
          <Button
            w="102px"
            h="40px"
            bg="#F2F2F2"
            color={"#333333"}
            fontSize="14px"
            fontWeight={"normal"}
            borderRadius={0}
            _hover={{}}
            onClick={handleAccessHistory}
          >
            查看
          </Button> */}
        </Box>
      </Box>

      {/* 更改邮箱 */}
      <Modal isOpen={emailControl.isOpen} onClose={emailControl.onClose}>
        <ModalOverlay />
        <ModalContent w="420px" bg="#575757">
          <ModalHeader color="#FFFFFF" fontSize={"18px"}>
            更换邮箱
          </ModalHeader>
          <ModalCloseButton color={"#B9B9B9"} />
          <ModalBody pb={6}>
            <FormControl>
              <FormLabel color="#8E94A9" fontSize={"14px"}>
                旧邮箱
              </FormLabel>
              <Input
                h="46px"
                bg="rgba(0, 0, 0, 0.3)"
                color="#fff"
                fontSize={"14px"}
                border="none"
                borderRadius={0}
                isDisabled
                value={email}
              />
            </FormControl>
            <Formik
              initialValues={emailForm}
              onSubmit={handleSubmitEmail}
              validate={handleValidate1}
            >
              {({ setFieldTouched, values }) => (
                <Form>
                  <Field name="email">
                    {({ field, form }: any) => (
                      <FormControl
                        mt={"20px"}
                        isInvalid={form.errors.email && form.touched.email}
                      >
                        <FormLabel color="#8E94A9" fontSize={"14px"}>
                          新建邮箱地址
                        </FormLabel>
                        <Input
                          {...field}
                          h="46px"
                          bg="rgba(0, 0, 0, 0.3)"
                          color="#fff"
                          fontSize={"14px"}
                          border="none"
                          borderRadius={0}
                        />
                        <FormErrorMessage>{form.errors.email}</FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                  <Field name="email2">
                    {({ field, form }: any) => (
                      <FormControl
                        mt={"20px"}
                        isInvalid={form.errors.email2 && form.touched.email2}
                      >
                        <FormLabel color="#8E94A9" fontSize={"14px"}>
                          确认邮箱地址
                        </FormLabel>
                        <Input
                          {...field}
                          h="46px"
                          bg="rgba(0, 0, 0, 0.3)"
                          color="#fff"
                          fontSize={"14px"}
                          border="none"
                          borderRadius={0}
                        />
                        <FormErrorMessage>
                          {form.errors.email2}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                  <Field name="password">
                    {({ field, form }: any) => (
                      <FormControl
                        mt={"20px"}
                        isInvalid={
                          form.errors.password && form.touched.password
                        }
                      >
                        <FormLabel color="#8E94A9" fontSize={"14px"}>
                          当前密码
                        </FormLabel>
                        <Input
                          {...field}
                          h="46px"
                          bg="rgba(0, 0, 0, 0.3)"
                          color="#fff"
                          fontSize={"14px"}
                          border="none"
                          borderRadius={0}
                          placeholder="请输入当前密码"
                        />
                        <FormErrorMessage>
                          {form.errors.password}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>

                  <Flex mt="40px" justifyContent={"flex-end"}>
                    <Button
                      w="76px"
                      h="37px"
                      mr="15px"
                      bg="#CBD1DF"
                      color={"#27314D"}
                      fontSize="12px"
                      fontWeight={"normal"}
                      borderRadius={0}
                      _hover={{
                        bg: "#CBD1DF",
                        color: "#8E94A9",
                      }}
                      onClick={handleCloseEmail}
                    >
                      取消
                    </Button>
                    <Button
                      w="76px"
                      h="37px"
                      bg="#496AE1"
                      color={"#FFFFFF"}
                      fontSize="12px"
                      fontWeight={"normal"}
                      borderRadius={0}
                      _hover={{
                        bg: "#3F5BC1",
                        color: "#E6E6E6",
                      }}
                      type="submit"
                    >
                      完成
                    </Button>
                  </Flex>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>


      {/* 更改手机 */}
      <Modal isOpen={phoneControl.isOpen} onClose={phoneControl.onClose}>
        <ModalOverlay />
        <ModalContent w="420px" bg="#575757">
          <ModalHeader color="#FFFFFF" fontSize={"18px"}>
            更换手机账号
          </ModalHeader>
          <ModalCloseButton color={"#B9B9B9"} />
          <ModalBody pb={6}>
            <Formik
              initialValues={newPhoneForm}
              onSubmit={handleSumbitPhone}
              validate={handlePhoneValidate2}
            >
              {({ setFieldTouched, values }) => (
                <Form>
                  <Field name="phone">
                    {({ field, form }: any) => (
                      <FormControl
                        isInvalid={
                          form.errors.phone && form.touched.phone
                        }
                      >
                        <FormLabel color="#8E94A9" fontSize={"14px"}>
                          绑定新手机
                        </FormLabel>
                        <Input
                          {...field}
                          h="46px"
                          bg="rgba(0, 0, 0, 0.3)"
                          color="#fff"
                          fontSize={"14px"}
                          border="none"
                          borderRadius={0}
                        />
                        <FormErrorMessage>
                          {form.errors.phone}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                  {isVerifyNewPhone && (
                    <Field name="code">
                      {({ field, form }: any) => (
                        <FormControl
                          mt={"20px"}
                          isInvalid={
                            form.errors.code &&
                            form.touched.code
                          }
                        >
                          <HStack spacing={"18px"}>
                            <Input
                              {...field}
                              h="46px"
                              bg="rgba(0, 0, 0, 0.3)"
                              color="#fff"
                              fontSize={"14px"}
                              border="none"
                              borderRadius={0}
                              placeholder="验证码"
                            />
                            <Button
                              w="112px"
                              h="46px"
                              bg="rgba(0, 0, 0, 0.3)"
                              color={"#CBD1DF"}
                              fontSize="12px"
                              fontWeight={"normal"}
                              borderRadius={0}
                              _hover={{
                                color: "#8E94A9",
                              }}
                              isDisabled={isPhoneDisable}
                              onClick={() => {
                                handleGetPhoneCode(setFieldTouched, values);
                              }}
                            >
                              {phoneBtnTxt}
                            </Button>
                          </HStack>
                          <FormErrorMessage>
                            {form.errors.newPhoneCode}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                  )}
                  <Flex mt="40px" justifyContent={"flex-end"}>
                    {!isVerifyNewPhone && (
                      <Button
                        w="76px"
                        h="37px"
                        bg="#496AE1"
                        color={"#FFFFFF"}
                        fontSize="12px"
                        fontWeight={"normal"}
                        borderRadius={0}
                        _hover={{
                          bg: "#3F5BC1",
                          color: "#E6E6E6",
                        }}
                        onClick={handleChangePhoneNext}
                      >
                        下一步
                      </Button>
                    )}

                    {isVerifyNewPhone && (
                      <>
                        <Button
                          w="76px"
                          h="37px"
                          mr="15px"
                          bg="#CBD1DF"
                          color={"#27314D"}
                          fontSize="12px"
                          fontWeight={"normal"}
                          borderRadius={0}
                          _hover={{
                            bg: "#CBD1DF",
                            color: "#8E94A9",
                          }}
                          onClick={handleClosePhone}
                        >
                          取消
                        </Button>
                        <Button
                          w="76px"
                          h="37px"
                          bg="#496AE1"
                          color={"#FFFFFF"}
                          fontSize="12px"
                          fontWeight={"normal"}
                          borderRadius={0}
                          _hover={{
                            bg: "#3F5BC1",
                            color: "#E6E6E6",
                          }}
                          type="submit"
                        >
                          完成
                        </Button>
                      </>
                    )}
                  </Flex>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* 绑定微信 */}
      <Modal isOpen={bindWxControl.isOpen} onClose={bindWxControl.onClose}>
        <ModalOverlay />
        <ModalContent w="420px" bg="#575757">
          <ModalHeader color="#FFFFFF" textAlign={"center"} fontSize={"18px"}>
            扫一扫完成绑定
          </ModalHeader>
          <ModalCloseButton color={"#B9B9B9"} />
          <ModalBody pb={6}>
            <Box
              mb="26px"
              color="#8E94A9"
              textAlign={"center"}
              fontSize={"12px"}
            >
              微信扫码
            </Box>
            <Center>
              <Box w="147px" h="147px" p="10px" bg="#fff">
                <QRCode size={127} value={wxQrcode} />
              </Box>
              
            </Center>
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* 更改密码 */}
      <Modal isOpen={passwordControl.isOpen} onClose={passwordControl.onClose}>
        <ModalOverlay />
        <ModalContent w="420px" bg="#575757">
          <ModalHeader color="#FFFFFF" fontSize={"18px"}>
            密码设置
          </ModalHeader>
          <ModalCloseButton color={"#B9B9B9"} />
          <ModalBody pb={6}>
            <FormControl>
              <Input
                h="46px"
                bg="rgba(0, 0, 0, 0.3)"
                color="#fff"
                fontSize={"14px"}
                border="none"
                borderRadius={0}
                value={password}
                onChange={handleChangePassword}
                placeholder="当前密码"
              />
            </FormControl>
            <FormControl mt="20px">
              <Input
                h="46px"
                bg="rgba(0, 0, 0, 0.3)"
                color="#fff"
                fontSize={"14px"}
                border="none"
                borderRadius={0}
                value={newPassword1}
                placeholder="新密码"
                onChange={handleChangeNewPassword1}
              />
            </FormControl>
            <FormControl mt="20px">
              <Input
                h="46px"
                bg="rgba(0, 0, 0, 0.3)"
                color="#fff"
                fontSize={"14px"}
                border="none"
                placeholder="确定新密码"
                borderRadius={0}
                value={newPassword2}
                onChange={handleChangeNewPassword2}
              />
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button
              w="76px"
              h="37px"
              mr="15px"
              bg="#CBD1DF"
              color={"#27314D"}
              fontSize="12px"
              fontWeight={"normal"}
              borderRadius={0}
              _hover={{
                bg: "#CBD1DF",
                color: "#8E94A9",
              }}
              onClick={handleClosePassword}
            >
              取消
            </Button>
            <Button
              w="76px"
              h="37px"
              bg="#496AE1"
              color={"#FFFFFF"}
              fontSize="12px"
              fontWeight={"normal"}
              borderRadius={0}
              _hover={{
                bg: "#3F5BC1",
                color: "#E6E6E6",
              }}
              onClick={handleSumbitPassword}
            >
              完成
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/*  查看访问历史 */}
      <AccessHistoryModal
        isOpen={accessControl.isOpen}
        onClose={accessControl.onClose}
        dataList={accessHistoryData}
      />
    </Box>
  );
};

export default SecuritySet;
